export default {
  setAccountTab: function() {
    console.log('test example')
  }
}
